import React, { Fragment } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Alert from "../layouts/Alert";
const HomeTemplate = (props) => {
  return (
    <Fragment>
      <Header
        history={props.children.props.history}
        location={props.children.props.location}
      />
      <div className='row mr-2 ml-2  overflow-hidden'>
        <div className='col-xl-10 col-lg-9 px-0 px-md-4'>
          <div className='mt-2 mb-5 p-0'>
            <Alert />
            {props.children}
          </div>
        </div>
        <div className='col-lg-3 col-xl-2 mt-2'>
          <Sidebar />
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default HomeTemplate;
